import styled from "styled-components";

export const SwitchWrapper = styled.div`
  width: ${(props) => props.width || "300px"};
  height: ${(props) => props.height || "70px"};
  padding: 15px;
  margin: 40px auto;
  border: 5px solid transparent;
display: flex;
position: relative;
  border-radius: 20px;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(
    90deg,
    #06d9ca 4.88%,
    #19b6f0 46.67%,
    #6e6cff 86.76%
  );
  div {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  cursor: pointer;
`;



export const SwitchContainer = styled.div`
  width: 50%;
  position: absolute;
  height: 90%;
  margin: auto auto;
  cursor: pointer;

  background: linear-gradient(
    90deg,
    #06d9ca 4.88%,
    #19b6f0 46.67%,
    #6e6cff 86.76%
  );
  border-radius: 5px;
  top: 0;
  bottom: 0;
  cursor: pointer;
  right: ${(props) => (props.isLeft ? "48%" : "0%")};
  left: ${(props) => (props.isLeft ? "0%" : "48%")};
  z-index: 0;
  transition: right 200ms linear;
  transition: left 200ms linear;
`;